let id = 0;

export function nextId() {
    id = id + 1;
    return id;
};
